"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomStyles = exports.Container = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Container = _styledComponents.default.div`
  ${(0, _layout.setContainer)({
  size: 'md'
})}
`;
exports.Container = Container;
const CustomStyles = (0, _styledComponents.createGlobalStyle)`
      h1, h2, h3, h4, h5, h6, p {
        margin: 0px;
        ${(0, _typography.setFont)({
  bold: true
})}
        ${(0, _typography.setFontSizes)({
  xs: '24px',
  lg: '32px',
  xl: '40px'
})}
      }
      ul {
        list-style: none;
        margin: 0px; 
        padding: 0px;
      }
      p {
          ${(0, _typography.setFont)({
  bold: false
})}
         ${(0, _typography.setFontSizes)({
  xs: '16px',
  lg: '19px',
  xl: '19px'
})}
      }
    `;
exports.CustomStyles = CustomStyles;
//# sourceMappingURL=styles.js.map